import { FC } from 'react';
import { Modal } from '../../../components';
import { Fade, Typography, Box, ButtonGroup, Button } from '@mui/material';

interface ISpendLimitModal {
  open: boolean;
  handleClose: (val?: string) => void;
  message: string;
}

export const SpendLimitModal: FC<ISpendLimitModal> = ({ open, handleClose, message }) => {
  return (
    <Modal
      open={open}
      showClose={false}
      onClose={(e, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
          handleClose();
        }
      }}
      maxWidth="xs"
    >
      <Fade in={open}>
        <div>
          <Typography align="center" paragraph>
            {message}
          </Typography>
          <Typography align="center" paragraph>
            Place Order?
          </Typography>
          <Box display="flex" justifyContent="center">
            <ButtonGroup>
              <Button variant="contained" onClick={() => handleClose('No')}>
                No
              </Button>
              <Button variant="contained" color="primary" onClick={() => handleClose('Yes')}>
                Yes
              </Button>
            </ButtonGroup>
          </Box>
        </div>
      </Fade>
    </Modal>
  );
};
